import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewContainerRef,
} from '@angular/core';
import {
  IDataDialogContent,
  ISubmitDialogContent,
} from '../../../Abstractions/Auth/ISubmitDialogContent';

@Component({
    selector: 'app-submit-dialog',
    imports: [],
    templateUrl: './submit-dialog.component.html',
    styleUrl: './submit-dialog.component.scss'
})
export class SubmitDialogComponent implements IDataDialogContent, OnInit {
  @Input() dialogRef!: ViewContainerRef;
  @Input() data?: ISubmitDialogContent;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  clearStyle() {
    this.renderer.removeStyle(document.body, 'overflow');
  }

  cancelAction() {
    this.clearStyle();
    this.dialogRef.clear();
  }
}
